/** Interface strings live behind keys from day one (SPEC 11.1); only `ru` exists. */
export const ru = {
  'day.title': 'Конверт дня',
  'day.empty': 'Конверт пуст. Сегодня ничего не запланировано.',
  'day.done': 'Сделано сегодня',
  'day.mode.normal': 'Обычный',
  'day.mode.hard': 'Тяжёлый',
  'day.mode.off': 'Выходной',
  'day.carryover': 'Из вчера ждут решения',
  'day.proposals': 'Предложения',
  'load.of': 'из',
  'load.energy': 'Энергия',
  'load.exceeded': 'Лимит дня превышен',
  'load.unestimated': 'без оценки',
  'card.done': 'Выполнено',
  'card.move': 'Переложить',
  'card.waiting': 'Ожидание',
  'card.note': 'Пометка',
  'card.trash': 'В корзину',
  'card.private': 'Приватная',
  'card.rescheduled': 'Переносилась',
  'card.notes': 'Пометки',
  'card.lay_in': 'лежала в',
  'card.focus_dates': 'В конверте дня',
  'card.add_note': 'Добавить пометку',
  'card.edit': 'Изменить',
  'card.save': 'Сохранить',
  'card.title_field': 'Название',
  'card.body_field': 'Текст',
  'move.title': 'Куда переложить',
  'move.today': 'Сегодня',
  'move.tomorrow': 'Завтра',
  'move.pick_date': 'Выбрать дату',
  'move.week': 'Эта неделя',
  'move.next_week': 'Следующая неделя',
  'move.month': 'Этот месяц',
  'move.next_month': 'Следующий месяц',
  'move.someday': 'Someday',
  'move.inbox': 'Бэклог',
  'move.confirm': 'Всё равно положить',
  'move.reason': 'Причина (необязательно)',
  'move.cancel': 'Отмена',
  'triage.title': 'Разбор',
  'triage.subtitle': 'Из вчера ждут решения',
  'triage.progress': 'Осталось',
  'triage.empty': 'Разбор закончен. Ничего не ждёт решения.',
  'triage.today': 'Сегодня',
  'triage.tomorrow': 'Завтра',
  'triage.week': 'На неделю',
  'triage.next_week': 'На следующую неделю',
  'triage.month': 'На месяц',
  'triage.next_month': 'На следующий месяц',
  'triage.someday': 'В Someday',
  'triage.done': 'Уже сделано',
  'triage.trash': 'В корзину',
  'triage.pick_date': 'Выбрать дату',
  'triage.waiting_question': 'Ответ пришёл?',
  'triage.advice': 'Переносилась несколько раз. Может, разбить на части, отдать или отложить?',
  'triage.close': 'Закрыть разбор',
  'index.title': 'Картотека',
  'index.drawers': 'Ящики',
  'index.days': 'Ближайшие дни',
  'piggybank.title': 'Копилка',
  'piggybank.today': 'Сегодня',
  'piggybank.week': 'За неделю',
  'piggybank.month': 'За месяц',
  'piggybank.total': 'Всего',
  'piggybank.by_kind': 'Из них',
  'piggybank.factor': 'Твои оценки обычно отличаются в',
  'piggybank.factor_sample': 'по последним задачам с фактом',
  'assistant.title': 'Ассистент',
  'assistant.placeholder': 'Напиши, что нужно',
  'assistant.send': 'Отправить',
  'assistant.thinking': 'Думаю…',
  'assistant.apply': 'Применить',
  'assistant.reject': 'Отклонить',
  'assistant.revise': 'Изменить',
  'assistant.revise_placeholder': 'Что поправить',
  'assistant.empty': 'Спроси что угодно: «перенеси всё лёгкое на четверг», «что у меня на среду».',
  'assistant.off': 'ИИ выключен в настройках.',
  'assistant.load_after': 'Станет',
  'assistant.limit': 'Лимит будет превышен',
  'assistant.force': 'Всё равно применить',
  'rules.title': 'Правила',
  'rules.hard': 'Жёсткие — их проверяет код',
  'rules.style': 'Предпочтения — идут в подсказку ассистенту',
  'rules.empty': 'Правил пока нет.',
  'rules.add': 'Добавить предпочтение',
  'rules.placeholder': 'Например: пиши коротко, без вопросов по мелочам',
  'rules.disable': 'Выключить',
  'rules.enable': 'Включить',
  'rules.not_guaranteed': 'не гарантируется кодом',
  'nav.rules': 'Правила',
  'nav.day': 'День',
  'nav.index': 'Картотека',
  'nav.piggybank': 'Копилка',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.undo': 'Откатить',
  'common.loading': 'Загружаю…',
  'common.error': 'Не получилось',
  'new.title': 'Новая карточка',
  'kind.task': 'Задача',
  'kind.meeting': 'Встреча',
  'kind.reminder': 'Напоминание',
  'kind.note': 'Заметка',
  'kind.project': 'Проект',
  'new.placeholder.task': 'Что нужно сделать',
  'new.placeholder.meeting': 'С кем и о чём встреча',
  'new.placeholder.reminder': 'О чём напомнить',
  'new.placeholder.note': 'Что записать',
  'new.placeholder.project': 'Название проекта',
  'new.date': 'Дата',
  'new.start': 'Начало',
  'new.duration': 'Длительность',
  'new.place': 'Место (необязательно)',
  'new.remind_time': 'Время (необязательно)',
  'new.note_body': 'Текст заметки',
  'new.note_title': 'Заголовок (необязательно)',
  'new.deadline': 'Дедлайн (необязательно)',
  'new.placeholder': 'Что нужно сделать',
  'new.time': 'Время',
  'new.energy': 'Энергия',
  'new.create': 'Положить',
  'new.to_inbox': 'В Бэклог без оценок',
  'energy.green': 'Легко',
  'energy.yellow': 'Немного влом',
  'energy.red': 'Трудно',
} as const;

export type MessageKey = keyof typeof ru;

export function t(key: MessageKey): string {
  return ru[key];
}
